import { Routes } from '@angular/router';
import { provideInstructorStore } from '@app/store/instructor';
import { ModalComponent } from '@shared/components';
import { AddComponent } from './add/add.component';
import { ViewComponent } from './view/view.component';
import { EditComponent } from './edit/edit.component';

export const instructorsModalRoutes: Routes = [
    {
        path: 'instructors/add',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideInstructorStore()],
        children: [{ path: '', component: AddComponent }],
    },
    {
        path: 'instructors/view/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideInstructorStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'instructors/edit/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideInstructorStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
